import React, { useState, SyntheticEvent, useEffect } from 'react';
import Navbar from '../../Navbar';
import Footer from '../../Footer';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import wabutton from '../../../Assets/Imagenes/wa_esp.png';
import './ShowVeterinarian.css';
import axios from 'axios';
import { MdVerified } from 'react-icons/md';
import { Rating } from 'react-simple-star-rating';
import { PerfilTypesToken } from '../../../Types/PerfilTypes';
import vetMaleImg from '../../../Assets/Imagenes/med_vet_m.png';
import vetFemaleImg from '../../../Assets/Imagenes/med_vet_f.png';
import AssignVet from './AssignVet';
import Posts from '../Posts';
import ReportForm from '../../Perfil/ReportForm';
function mapStateToProps(state: any) {
  return { action: state };
}

function ShowVeterinarian(props: PerfilTypesToken) {
  const { id } = useParams();
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [whatsApp, setWhatsApp] = useState<string>('');
  const [image, setImage] = useState<string>('');
  const [address, setAddress] = useState<string>('');
  const [region, setRegion] = useState<string>('');
  const [comune, setComune] = useState<string>('');
  const [area, setArea] = useState<string>('');
  const [verified, setVerified] = useState<string>('');
  const [gender, setGender] = useState<string>('');
  const [rating, setRating] = useState<number>(0);
  const [canRate, setcanRate] = useState(false);
  const [urlCalendly, setUrlCalendly] = useState<string>('');
  const [hoverVerified, setHoverVerified] = useState(false);
  const [assign, setAssign] = useState(false);

  useEffect(() => {
    fetchVetData();
  }, []);

  const fetchVetData = async () => {
    const token = JSON.parse(localStorage.getItem('token') || '');
    try {
      const response = await axios.get(process.env.REACT_APP_URL + '/vets/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      });

      setRating(response.data.vet.score);
      setcanRate(!response.data.vet.rankedByUser);
      setName(response.data.vet.name);
      setArea(response.data.vet.area);
      setEmail(response.data.vet.email);
      setImage(response.data.vet.profileUrlImg);
      setAddress(response.data.vet.address);
      setRegion(response.data.vet.addressRegion);
      setComune(response.data.vet.addressComuna);
      setVerified(response.data.vet.verified_status);
      setGender(response.data.vet.gender);

      const numarray = response.data.vet.phone.split('');
      const num = '(' + numarray.slice(0, 4).join('') + ')' + ' ' + numarray.slice(4, 8).join('') + ' ' + numarray.slice(7, 11).join('');
      if (response.data.vet.phone.slice(0, 4) === '+569') {
        setWhatsApp(response.data.vet.phone.slice(1));
      }
      setPhone(num);

      // Fetch calendar data
      const calendarResponse = await axios.get(process.env.REACT_APP_URL + '/vets/calendar/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      });
      setUrlCalendly(calendarResponse.data.vetCalendar);
    } catch (error) {
      console.error('Error fetching vet data:', error);
    }
  };

  async function rateVet(rate: number) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.post(process.env.REACT_APP_URL + '/vetReviews/new/' + id + '/' + props.action.user.credenciales.id, {
      score: rate
    }, { headers: { Authorization: 'Bearer ' + token } });
  }

  function handleRating(rate: number) {
    setRating(rate);
    setcanRate(false);
    rateVet(rate);
  }

  function toggleAssignVet(event: SyntheticEvent) {
    event.preventDefault();
    setAssign(!assign);
  }

  const InfoField = ({ label, value }: { label: string; value: string }) => (
    <div className="field-block">
      <div className="field-label">{label}</div>
      <div className="field-value">{value}</div>
    </div>
  );

  return (
    <div className="wrapper">
      <Navbar logged={true} />
      <div className='spacer32'></div>
      <h6 className='navigation-info-post-post ms-3'>M. Veterinarios/as / {name}</h6>
      <div className='spacer32'></div>
      <div className='container-perfil' style={{ flexGrow: 1 }}>
        <ReportForm />
        <div className='col-auto' style={{ width: '100%' }}>
          <div className='row' style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignContent: 'center', margin: '0px' }}>
            <div className='col-auto'>
              <div className='row'>
                <div className='col-auto'>
                  <div className='Box-foto'>
                    <img
                      src={image || (gender === 'FEMALE' ? vetFemaleImg : vetMaleImg)}
                      alt='Veterinarian profile'
                      style={{ borderRadius: '10px', backgroundImage: 'none', width: '15rem' }}
                    />
                  </div>
                  <div className='spacer20'></div>
                </div>
                <div className='col-auto' style={{ marginLeft: '58px', padding: '0px' }}>
                  <div className='row'>
                    {verified === 'verified'
                      ? <div style={{ position: 'relative' }} className='col-auto texto-nombre'>
                          {name}
                          <MdVerified
                            onMouseOver={() => setHoverVerified(true)}
                            onMouseOut={() => setHoverVerified(false)}
                            style={{ fill: '#C75100', cursor: 'pointer' }}
                          />
                          {hoverVerified &&
                            <span style={{
                              position: 'absolute',
                              backgroundColor: '#C75100',
                              color: 'white',
                              padding: '5px',
                              fontSize: '24px',
                              borderRadius: '5px',
                              bottom: '60px',
                              right: '5px',
                              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
                            }}>
                              Médico/a veterinario/a verificado
                            </span>
                          }
                        </div>
                      : <div className='col-auto texto-nombre'>{name}</div>
                    }
                    {whatsApp !== '' &&
                      <div className='box-whatsapp'>
                        <a href={'https://wa.me/' + whatsApp + '?text=Hola!%20Quiero%20consultar%20por%20los%20servicios%20que%20ofrece%20en%20Vepet.'}>
                          <img alt="Chat on WhatsApp" src={wabutton} />
                        </a>
                      </div>
                    }
                  </div>
                  <div className='row'>
                    <div className='col-auto texto-mail'>{email}</div>
                  </div>
                  <div className='row' style={{ marginTop: '20px' }}>
                    <div className='col-auto' style={{ marginRight: '58px' }}>
                      {canRate &&
                        <Rating
                          onClick={handleRating}
                          allowFraction={true}
                          fillIcon={null}
                          showTooltip={true}
                          tooltipDefaultText='Califica al Médico/a Veterinario/a'
                        />
                      }
                    </div>
                    <div className='spacer12'></div>
                    <div className='col-auto texto-mail'>Calificación: {rating.toFixed() + '/5'} ⭐</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="service-info-container">
            <div className="section-title">Información del Médico/a Veterinario/a</div>
            <div className="info-grid">
              <div className="info-column">
                <InfoField label="Teléfono" value={phone} />
                <InfoField label="Dirección" value={address} />
                <InfoField label="Región" value={region} />
                <InfoField label="Comuna" value={comune} />
                <InfoField label="Especialidad" value={area} />
              </div>
            </div>
          </div>
          <Posts/>

          {urlCalendly && (
            <div style={{ margin: 'auto', width: 'fit-content' }}>
              <Link to={'/calendar'} state={{ urlCalendly }}>
                <button className="petsitter-hire-button" style={{ width: '200px', height: '45px', marginRight: '1rem' }}>
                  Reservar Hora
                </button>
              </Link>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', margin: '1rem' }}>
            <Link to='/veterinarios' className='link-back-veterinarians-show'>Volver</Link>
            <button onClick={toggleAssignVet} className="solicitar-acceso-boton" style={{ padding: '14px' }}>
              Asignar a mi mascota
            </button>
          </div>
        </div>
      </div>

      {assign && (
        <div className="register-form-container">
          <div className="register-form-content">
            <AssignVet toggleAssignVet={toggleAssignVet} />
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default connect(mapStateToProps)(ShowVeterinarian);
